// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Expln_React_Column = require("@expln/utils/src/main/Expln_React_Column.bs.js");
var Expln_React_common = require("@expln/utils/src/main/Expln_React_common.bs.js");
var Button = require("@mui/material/Button").default;
var TextField = require("@mui/material/TextField").default;

function JsonParseView(Props) {
  var match = React.useState(function () {
        return "";
      });
  var setJsonStr = match[1];
  console.log("jsonStr", match[0]);
  var onJsonStrChange = function (param) {
    return Expln_React_common.evt2str((function (str) {
                  Curry._1(setJsonStr, (function (param) {
                          return str;
                        }));
                }), param);
  };
  return React.createElement(Expln_React_Column.make, {
              spacing: 2,
              style: {
                padding: "10px"
              },
              children: null
            }, React.createElement(TextField, {
                  label: "JSON",
                  size: "small",
                  multiline: true,
                  maxRows: 20,
                  onChange: onJsonStrChange,
                  inputProps: {
                    size: 20
                  }
                }), React.createElement(Button, {
                  onClick: (function (param) {
                      console.log("Click!");
                    }),
                  variant: "contained",
                  children: "Parse JSON"
                }));
}

var make = JsonParseView;

exports.make = make;
/* react Not a pure module */
